import { render, staticRenderFns } from "./examinePage.vue?vue&type=template&id=3c3bb01c&scoped=true&"
import script from "./examinePage.vue?vue&type=script&lang=js&"
export * from "./examinePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3bb01c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdGG/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3bb01c')) {
      api.createRecord('3c3bb01c', component.options)
    } else {
      api.reload('3c3bb01c', component.options)
    }
    module.hot.accept("./examinePage.vue?vue&type=template&id=3c3bb01c&scoped=true&", function () {
      api.rerender('3c3bb01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/pv/examinePage.vue"
export default component.exports